import router                             from '@/router';
import store                              from '@/store';
import { VDataTable, VDataTableVirtual } from 'vuetify/labs/VDataTable'
import StudentDataService                 from './services/StudentDataService';

import {
    Chart as ChartJS,
    ArcElement, Tooltip, Legend, Title,
    BarElement, PointElement, LineElement,
    CategoryScale, LinearScale,
} from 'chart.js'
import { Doughnut, Bar, Line } from 'vue-chartjs'

ChartJS.register(
    ArcElement, Tooltip, Legend, Title,
    BarElement, PointElement, LineElement,
    CategoryScale, LinearScale,
)

export default {

    name: 'AlunoNota',
    components: { Doughnut, Bar, Line, VDataTable, VDataTableVirtual },

    data: () => ({

        chartDataGauge:    null,
        chartDataGaugeAI:  null,
        chartDataGaugeAE:  null,
        chartDataBarAI:    null,
        chartDataBarAE:    null,
        chartDataLine:     null,
        chartDataAllStacked: null,
        chartDataAllGauges: [],

        charOptionsGauge: {
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: '70%',
            plugins: {
                legend: { display: false },
                tooltip: { enabled: true },
            },
        },
        charOptionsBarPerQ: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'top' } },
            scales: { y: { beginAtZero: true } },
        },
        charOptionsLine: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'top' } },
            scales: {
                y: { beginAtZero: true },
            },
        },
        charOptionsStacked: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'top' } },
            scales: {
                x: { stacked: true },
                y: { stacked: true, beginAtZero: true },
            },
        },

        datetime: '',
        headersStudentsGrades: [],
        headersTests: [
            { title: 'Atividade Avaliativa', key: 'nome',            align: 'start',  width: '30%' },
            { title: 'Professor (a)',         key: 'prof',            align: 'center', width: '30%' },
            { title: 'Questoes',              key: 'n_questoes',       align: 'center', width: '10%' },
            { title: 'Status',                key: 'status_nome',     align: 'center', width: '20%' },
            { title: 'Criacao',               key: 'datetime',        align: 'center', width: '10%' },
        ],
        json_fields: {},
        listStudentGrades: [],
        listTests: [],
        loadingStudentsGrades: true,
        loadingTests: true,
        notaEquipe: '',
        notaIndividual: '',
        notaMaxima: '',
        nQuestoes: '',
        optGabarito: false,
        perguntas: [],
        sortByData: [{ key: 'datetime', order: 'desc' }],
        sortByName: [{ key: 'nome_usuario', order: 'asc' }],
        provaId: '',
        provaNome: '',
        provaProf: '',
        provaSenha: '',
        pt: '',
        sbColor: '',
        sbMessage: '',
        snackbar: false,
        statusNomeProva: '',
        statusProva: '',
    }),

    mounted() {
        this.handlePageChange(this.currentParamsPage);
    },

    computed: {
        currentParamsPage() {
            return this.$route.params;
        },
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        },
        currentParamsPage(newVal, _oldVal) {
            this.handlePageChange(newVal);
        },
    },

    methods: {

        convertHeadersToJSON(headers) {
            const json_fields = {};
            for (const header of headers) {
                json_fields[header.title] = header.key;
            }
            return json_fields;
        },

        exportToPDF() {
            html2pdf(this.$refs.elementToConvert, {
                margin: 1,
                filename: 'document.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { dpi: 192, letterRendering: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
            });
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo' }).format(date);
        },

        formatDateTime(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('pt-BR', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                timezone: 'America/Sao_Paulo',
            }).format(date);
        },

        getGradeGaugeColor(score, maxScore) {
            const value = Number(score);
            const max = Number(maxScore);
            if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) {
                return '#B00020';
            }

            const percent = (value / max) * 100;
            if (percent < 30) {
                return '#B00020';
            }
            if (percent < 60) {
                return '#FBC02D';
            }
            return '#2E7D32';
        },

        buildGradeGaugeData(score, maxScore, obtainedLabel = 'Minha Nota') {
            const value = Number(score);
            const max = Number(maxScore);
            const safeValue = Number.isFinite(value) ? value : 0;
            const safeMax = Number.isFinite(max) && max > 0 ? max : 0;
            const filled = safeMax > 0 ? Math.min(Math.max(safeValue, 0), safeMax) : 0;
            const remaining = Math.max(0, safeMax - filled);
            const percent = safeMax > 0 ? (safeValue / safeMax) * 100 : 0;
            const displayPercent = Math.max(0, Math.min(percent, 100));

            return {
                labels: [
                    `${obtainedLabel} (${displayPercent.toFixed(1)}%)`,
                    `Restante (${Math.max(0, 100 - displayPercent).toFixed(1)}%)`,
                ],
                datasets: [{
                    data: [filled, remaining],
                    backgroundColor: [this.getGradeGaugeColor(safeValue, safeMax), '#E5E7EB'],
                    borderWidth: 0,
                }],
            };
        },

        formatGrade(value) {
            const number = Number(value || 0);
            return number.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },

        getStudentGrades(id) {

            StudentDataService.studentTest(id).then(response => {

                this.provaProf  = response.data.prof;
                const prova     = response.data.prova;
                const npi       = response.data.notas_prova_individual;
                const npg       = response.data.notas_prova_grupo;

                if (store.state.userSex === 'm' || store.state.userSex === 'ni') { this.pt = 'Professor:'; }
                else if (store.state.userSex === 'f') { this.pt = 'Professora: '; }

                this.provaNome      = prova.nome;
                this.datetime       = this.formatDateTime(prova.datetime);
                this.statusProva    = prova.get_status_display;
                if (prova.opt_gabarito === true) {
                    this.optGabarito = 'O questionario com gabarito esta sendo exibido ao aluno';
                }
                this.notaMaxima     = prova.nota_maxima;
                this.notaIndividual = (prova.nota_individual * prova.nota_maxima) / 100;
                this.notaEquipe     = (prova.nota_equipe * prova.nota_maxima) / 100;

                if (npi || npg) {

                    const numQuestions    = prova.perguntas.length;
                    const numAlts         = prova.perguntas[0].answers.length;
                    const perguntas       = prova.perguntas;
                    const valueQuestionPI = this.notaIndividual / numQuestions;
                    const valueQuestionPG = this.notaEquipe / numQuestions;

                    if (this.headersStudentsGrades.length > 1) {
                        this.headersStudentsGrades = [];
                    }

                    for (let i = 0; i < numQuestions; i++) {
                        this.headersStudentsGrades.push({ title: `PI Q${i+1}`, key: `nota_${i+1}`, align: 'center', sortable: true });
                    }
                    this.headersStudentsGrades.push({ title: 'PI Total', key: 'totalPI', align: 'center', sortable: true });

                    for (let i = 0; i < numQuestions; i++) {
                        this.headersStudentsGrades.push({ title: `PG Q${i+1}`, key: `notag_${i+1}`, align: 'center', sortable: true });
                    }
                    this.headersStudentsGrades.push({ title: 'PG Total',    key: 'totalPG', align: 'center', sortable: true });
                    this.headersStudentsGrades.push({ title: 'Total Final', key: 'totalF',  align: 'center', sortable: true });

                    let nota;
                    let total  = 0;
                    let totalg = 0;

                    const piPerQuestion = [];
                    const pgPerQuestion = [];

                    for (let j = 0; j < numQuestions; j++) {
                        const altTrue = parseInt(perguntas[j].altTrue);
                        let qScore = 0;

                        for (let l = 0; l < numAlts; l++) {
                            const altPos = l + 1;
                            if (npi.respostas[j]?.answers[l].answer) {
                                const answer = parseInt(npi.respostas[j].answers[l].answer);
                                if (altPos === altTrue) {
                                    nota              = ((answer / numAlts) * 100 * valueQuestionPI) / 100;
                                    npi['nota_' + (j+1)] = nota.toFixed(2);
                                    total += nota;
                                    qScore = nota;
                                }
                            }
                        }
                        piPerQuestion.push(parseFloat(qScore.toFixed(2)));

                        let notag  = 0;
                        const answer = npg.respostas['question' + (j+1)];
                        if (answer) {
                            for (let d = 0; d < answer.length; d++) {
                                if (parseInt(answer[d]) === altTrue) {
                                    if (d === 0)              { notag = valueQuestionPG; }
                                    else if (d < numAlts - 1) { notag = (100 / Math.pow(2, d) * valueQuestionPG) / 100; }
                                    npi['notag_' + (j+1)] = notag.toFixed(2);
                                    totalg += notag;
                                    break;
                                }
                            }
                        }
                        pgPerQuestion.push(parseFloat(notag.toFixed(2)));
                        npi.totalPG = totalg.toFixed(2);
                    }

                    npi.totalPI = total.toFixed(2);
                    npi.totalF  = (parseFloat(npi.totalPI) + parseFloat(npi.totalPG)).toFixed(2);

                    this.json_fields           = this.convertHeadersToJSON(this.headersStudentsGrades);
                    this.listStudentGrades     = [npi];
                    this.loadingStudentsGrades = false;

                    const notaFinal  = parseFloat(npi.totalF);
                    const piScore    = parseFloat(npi.totalPI);
                    const pgScore    = parseFloat(npi.totalPG);
                    const notaMax    = parseFloat(this.notaMaxima);
                    const piMax      = parseFloat(this.notaIndividual);
                    const pgMax      = parseFloat(this.notaEquipe);
                    const qLabels    = perguntas.map((_, i) => `Q${i + 1}`);

                    // Gauges por percentual do valor maximo de cada etapa
                    this.chartDataGauge   = this.buildGradeGaugeData(notaFinal, notaMax, 'Minha Nota');
                    this.chartDataGaugeAI = this.buildGradeGaugeData(piScore, piMax, 'AI Obtida');
                    this.chartDataGaugeAE = this.buildGradeGaugeData(pgScore, pgMax, 'AE Obtida');

                    // — Barras AI por questão —
                    this.chartDataBarAI = {
                        labels: qLabels,
                        datasets: [
                            { label: 'Minha Nota (AI)', backgroundColor: '#3C6E8F', data: piPerQuestion },
                            { label: 'Máximo', backgroundColor: 'rgba(60,110,143,0.2)', data: Array(numQuestions).fill(parseFloat(valueQuestionPI.toFixed(2))) },
                        ],
                    };

                    // — Barras AE por questão —
                    this.chartDataBarAE = {
                        labels: qLabels,
                        datasets: [
                            { label: 'Minha Nota (AE)', backgroundColor: '#B88645', data: pgPerQuestion },
                            { label: 'Máximo', backgroundColor: 'rgba(184,134,69,0.2)', data: Array(numQuestions).fill(parseFloat(valueQuestionPG.toFixed(2))) },
                        ],
                    };
                }

            }).catch(error => {
                console.log(error);
                this.sbColor   = 'error';
                this.sbMessage = 'Voce nao respondeu nenhuma questao na atividade avaliativa, procure o professor!';
                this.snackbar  = true;
                router.push({ path: '/aProvas/Listar' });
            });
        },

        async getTests() {
            await StudentDataService.listTests().then(async response => {
                this.listTests    = response.data;
                this.loadingTests = false;
            }).catch(error => {
                console.log(error);
            });
        },

        async buildGradeHistory(tests) {
            const concluded = tests
                .filter(t => String(t.status_nome || '').toLowerCase().includes('conclu'))
                .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

            const labels = [];
            const data   = [];
            const totalAI = [];
            const totalAE = [];
            const gauges = [];

            for (const test of concluded) {
                try {
                    const response = await StudentDataService.studentTest(test.id);
                    const prova    = response.data.prova;
                    const npi      = response.data.notas_prova_individual;
                    const npg      = response.data.notas_prova_grupo;

                    if (!npi || !npg) continue;

                    const numQuestions    = prova.perguntas.length;
                    const numAlts         = prova.perguntas[0].answers.length;
                    const notaIndividual  = (prova.nota_individual * prova.nota_maxima) / 100;
                    const notaEquipe      = (prova.nota_equipe * prova.nota_maxima) / 100;
                    const valueQuestionPI = notaIndividual / numQuestions;
                    const valueQuestionPG = notaEquipe / numQuestions;

                    let total  = 0;
                    let totalg = 0;

                    for (let j = 0; j < numQuestions; j++) {
                        const altTrue = parseInt(prova.perguntas[j].altTrue);
                        for (let l = 0; l < numAlts; l++) {
                            const altPos = l + 1;
                            if (npi.respostas[j]?.answers[l].answer) {
                                const answer = parseInt(npi.respostas[j].answers[l].answer);
                                if (altPos === altTrue) {
                                    total += ((answer / numAlts) * 100 * valueQuestionPI) / 100;
                                }
                            }
                        }
                        const answer = npg.respostas['question' + (j + 1)];
                        if (answer) {
                            for (let d = 0; d < answer.length; d++) {
                                if (parseInt(answer[d]) === altTrue) {
                                    if (d === 0)              { totalg += valueQuestionPG; }
                                    else if (d < numAlts - 1) { totalg += (100 / Math.pow(2, d) * valueQuestionPG) / 100; }
                                    break;
                                }
                            }
                        }
                    }

                    labels.push(test.nome || this.formatDate(prova.datetime));
                    const totalFinal = parseFloat((total + totalg).toFixed(2));
                    const totalPI = parseFloat(total.toFixed(2));
                    const totalPG = parseFloat(totalg.toFixed(2));
                    const label = test.nome || this.formatDate(prova.datetime);

                    data.push(totalFinal);
                    totalAI.push(totalPI);
                    totalAE.push(totalPG);
                    gauges.push({
                        id: test.id,
                        nome: label,
                        totalF: totalFinal,
                        notaMaxima: parseFloat(prova.nota_maxima),
                        chartData: this.buildGradeGaugeData(totalFinal, prova.nota_maxima, 'Nota Final'),
                    });
                } catch (_) {
                    // pular provas sem respostas
                }
            }

            this.chartDataAllGauges = gauges;

            if (data.length > 0) {
                this.chartDataAllStacked = {
                    labels,
                    datasets: [
                        { label: 'Atividade Individual (AI)', backgroundColor: '#3C6E8F', data: totalAI },
                        { label: 'Atividade em Equipe (AE)', backgroundColor: '#B88645', data: totalAE },
                    ],
                };
            } else {
                this.chartDataAllStacked = null;
            }

            if (data.length > 1) {
                this.chartDataLine = {
                    labels,
                    datasets: [{
                        label: 'Nota Final',
                        borderColor: '#3C6E8F',
                        backgroundColor: 'rgba(60,110,143,0.1)',
                        data,
                        tension: 0.3,
                        fill: true,
                        pointRadius: 5,
                        pointHoverRadius: 7,
                    }],
                };
            }
        },

        async handlePageChange(params) {
            clearInterval(this.interval);
            if (typeof params.id === 'undefined') {
                this.getTests();
            } else {
                this.listStudentGrades = [];
                this.getStudentGrades(params.id);
            }
        },

        rowClick(_item, row) {
            router.push({ path: '/aProvas/Notas/' + row.item.value });
        },
    },
};
